/* global __webpack_hash__ */
import { createApp } from 'vue'
import AppShell from './AppShell.vue'
import router from './router'
import './assets/global.css'
import '@/assets/styles/pygments.css'
import './assets/styles/typography.css'
import './assets/styles/motion.css'
import './assets/styles/layout.css'
import './assets/themes/_base-tokens.css'
import './assets/themes/standard-theme.css'
import './assets/themes/dark-theme.css'
// Brand families (data-theme-family): token overrides over the Cameron Sky base.
import './assets/themes/ffb-standard-theme.css'
import './assets/themes/ffb-dark-theme.css'
import './assets/themes/corp-bank-standard-theme.css'
import './assets/themes/corp-bank-dark-theme.css'
import './assets/themes/cyber-punk-standard-theme.css'
import './assets/themes/cyber-punk-dark-theme.css'
import './assets/themes/instrument-tokens.css'
import './assets/styles/instrument.css'
import { initCsrf } from './axios-config'   // uses relative /api path
import displaySettings from './utils/displaySettings'

// Theme is resolved pre-paint by the inline script in public/index.html and
// re-applied by App.vue via themeManager.initTheme().

// Text size / density / reading width (localStorage) before the first render.
displaySettings.apply();
displaySettings.syncAcrossTabs();

registerServiceWorker();

await initCsrf();

// AppShell is a bare <router-view />: '/' renders the chat app (App.vue),
// /rag/* renders RAG Studio (router.js).
const app = createApp(AppShell)
app.use(router)
app.mount('#app')

/**
 * Service worker (production builds only; see public/sw.js for the caching
 * strategy). Registered as `/sw.js?v=<build id>` so every deploy installs a
 * fresh worker whose caches are named after the build, even though sw.js is a
 * static, unhashed file. Kill switch for debugging: localStorage
 * `camgpt-sw-disabled` = '1' unregisters it on the next load.
 */
function registerServiceWorker() {
  if (process.env.NODE_ENV !== 'production') return;
  if (typeof window === 'undefined' || !('serviceWorker' in navigator) || !window.isSecureContext) return;

  const buildId = () => {
    if (typeof __webpack_hash__ !== 'undefined' && __webpack_hash__) return String(__webpack_hash__).slice(0, 16);
    const script = document.querySelector('script[src*="/js/app."]');
    const match = script && /\/js\/app\.([0-9a-f]+)\.js/.exec(script.getAttribute('src') || '');
    return match ? match[1] : 'dev';
  };
  const run = () => {
    let disabled = false;
    try { disabled = window.localStorage.getItem('camgpt-sw-disabled') === '1'; } catch (e) { /* storage disabled */ }
    if (disabled) {
      navigator.serviceWorker.getRegistrations()
        .then((regs) => Promise.all(regs.map((r) => r.unregister())))
        .catch(() => {});
      return;
    }
    navigator.serviceWorker
      .register(`/sw.js?v=${encodeURIComponent(buildId())}`, { scope: '/' })
      .catch((err) => console.warn('Service worker registration failed:', err));
  };
  if (document.readyState === 'complete') run();
  else window.addEventListener('load', run, { once: true });
}
